import states from '../states';

$(() => {
  const $extraInfo = $('.product-extra-info');

  if (!$extraInfo) {
    return;
  }

  const $buyNowTab = $('.buy-now-tab', $extraInfo);

  const $buyNowItems = $('.buy-now-items', $extraInfo);

  $buyNowTab.click(() => {
    $buyNowItems.slideToggle();
  });

  const initMobile = function initMobile() {
    $('.js-move-product-info').show();
  };

  const initDesktop = function initDesktop() {
    // Desktop technology bar position
    $('.js-move-product-info').insertAfter($('.breadcrumbs'));
    $('.js-move-product-info').show();
  };

  const destroyMobile = function destroyMobile() {};

  const destroyDesktop = function destroyDesktop() {
    // Remove Desktop technology bar position
    $('.product-extra-info').prepend($('.js-move-product-info'));
  };

  // Handle mobile states.
  states.getState('xs').on('enter', () => {
    destroyDesktop();
    initMobile();
  });

  states.getState('sm').on('enter', () => {
    destroyDesktop();
    initMobile();
  });

  // Handle desktop states.
  states.getState('md').on('enter', () => {
    destroyMobile();
    initDesktop();
  });

  states.getState('lg').on('enter', () => {
    destroyMobile();
    initDesktop();
  });

  // Initialise navigation.
  if (states.isActive('xs') || states.isActive('sm')) {
    initMobile();
  } else {
    initDesktop();
  }
});
